import axios from "axios";
import { getAccessToken } from "./authSession";
import { API_BASE_URL } from "../config";

const getAuthHeaders = () => {
    const token = getAccessToken();
    if (!token) {
        window.location.href = "/";
        return {};
    }
    return {
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
        },
    };
};

const getMultipartAuthHeaders = () => {
    const token = getAccessToken();
    if (!token) {
        window.location.href = "/";
        return {};
    }
    return {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    };
};

export const listWholesaleSuppliers = async () => {
    const response = await axios.get(`${API_BASE_URL}/fulfillment/wholesale-suppliers`, getAuthHeaders());
    return response.data;
};

export const createWholesaleSupplier = async (payload) => {
    const response = await axios.post(`${API_BASE_URL}/fulfillment/wholesale-suppliers`, payload, getAuthHeaders());
    return response.data;
};

export const updateWholesaleSupplier = async (supplierId, payload) => {
    const response = await axios.put(`${API_BASE_URL}/fulfillment/wholesale-suppliers/${supplierId}`, payload, getAuthHeaders());
    return response.data;
};
export const listWholesaleContentSources = async (supplierId) => (await axios.get(`${API_BASE_URL}/wholesale-suppliers/${supplierId}/content-sources`, getAuthHeaders())).data;
export const createWholesaleContentSource = async (supplierId, payload) => (await axios.post(`${API_BASE_URL}/wholesale-suppliers/${supplierId}/content-sources`, payload, getAuthHeaders())).data;
export const importSnimportWholesaleContent = async (supplierId, file) => {
    const data = new FormData();
    data.append("file", file);
    return (await axios.post(
        `${API_BASE_URL}/wholesale-suppliers/${supplierId}/content/snimport/import`,
        data,
        getMultipartAuthHeaders(),
    )).data;
};
export const runWholesaleContentSource = async (sourceId, file = null) => {
    const data = new FormData(); if (file) data.append("file", file);
    return (await axios.post(`${API_BASE_URL}/wholesale-content-sources/${sourceId}/run`, data, getMultipartAuthHeaders())).data;
};
export const listFulfillmentWholesaleRoutes = async (senderCode = null) => (await axios.get(`${API_BASE_URL}/fulfillment/wholesale-routes`, { ...getAuthHeaders(), params: senderCode ? { sender_code: senderCode } : {} })).data;
export const createFulfillmentWholesaleRoute = async (payload) => (await axios.post(`${API_BASE_URL}/fulfillment/wholesale-routes`, payload, getAuthHeaders())).data;
export const updateFulfillmentWholesaleRoute = async (id, payload) => (await axios.patch(`${API_BASE_URL}/fulfillment/wholesale-routes/${id}`, payload, getAuthHeaders())).data;
export const getFulfillmentSenderPricingProfile = async (senderCode) => (await axios.get(`${API_BASE_URL}/fulfillment/sender-pricing-profiles/${encodeURIComponent(senderCode)}`, getAuthHeaders())).data;
export const upsertFulfillmentSenderPricingProfile = async (senderCode, payload) => (await axios.put(`${API_BASE_URL}/fulfillment/sender-pricing-profiles/${encodeURIComponent(senderCode)}`, payload, getAuthHeaders())).data;

export const listSupplierLegalEntities = async (supplierId) => {
    const response = await axios.get(
        `${API_BASE_URL}/fulfillment/wholesale-suppliers/${supplierId}/legal-entities`,
        getAuthHeaders(),
    );
    return response.data;
};

export const createSupplierLegalEntity = async (supplierId, payload) => {
    const response = await axios.post(
        `${API_BASE_URL}/fulfillment/wholesale-suppliers/${supplierId}/legal-entities`,
        payload,
        getAuthHeaders(),
    );
    return response.data;
};

export const createSupplierParserProfile = async (supplierId, payload) => {
    const response = await axios.post(
        `${API_BASE_URL}/fulfillment/wholesale-suppliers/${supplierId}/parser-profiles`,
        payload,
        getAuthHeaders(),
    );
    return response.data;
};

export const listInboundInvoices = async (params) => {
    // params опциональны (warehouse_type, own_warehouse_id — контур «Склад»); без них запрос прежний.
    const response = await axios.get(
        `${API_BASE_URL}/fulfillment/inbound-invoices`,
        params ? { ...getAuthHeaders(), params } : getAuthHeaders(),
    );
    return response.data;
};

export const createInboundInvoice = async (payload) => {
    const response = await axios.post(`${API_BASE_URL}/fulfillment/inbound-invoices`, payload, getAuthHeaders());
    return response.data;
};

export const updateInboundInvoice = async (invoiceId, payload) => {
    const response = await axios.put(`${API_BASE_URL}/fulfillment/inbound-invoices/${invoiceId}`, payload, getAuthHeaders());
    return response.data;
};

export const copyInboundInvoice = async (invoiceId) => {
    const response = await axios.post(`${API_BASE_URL}/fulfillment/inbound-invoices/${invoiceId}/copy`, {}, getAuthHeaders());
    return response.data;
};

export const deleteInboundInvoice = async (invoiceId) => {
    const response = await axios.delete(`${API_BASE_URL}/fulfillment/inbound-invoices/${invoiceId}`, getAuthHeaders());
    return response.data;
};

export const getInboundInvoice = async (invoiceId) => {
    const response = await axios.get(`${API_BASE_URL}/fulfillment/inbound-invoices/${invoiceId}`, getAuthHeaders());
    return response.data;
};

export const uploadInvoiceAttachment = async (invoiceId, file) => {
    const formData = new FormData();
    formData.append("file", file);
    const response = await axios.post(
        `${API_BASE_URL}/fulfillment/inbound-invoices/${invoiceId}/attachments`,
        formData,
        getMultipartAuthHeaders(),
    );
    return response.data;
};

export const parseInboundInvoice = async (invoiceId) => {
    const response = await axios.post(`${API_BASE_URL}/fulfillment/inbound-invoices/${invoiceId}/parse`, {}, getAuthHeaders());
    return response.data;
};

export const syncInboundInvoiceIdentities = async (invoiceId) => {
    const response = await axios.post(`${API_BASE_URL}/fulfillment/inbound-invoices/${invoiceId}/identity-sync`, {}, getAuthHeaders());
    return response.data;
};

export const searchFulfillmentProducts = async (query) => {
    const response = await axios.get(`${API_BASE_URL}/fulfillment/master-products/search`, {
        ...getAuthHeaders(),
        params: { query },
    });
    return response.data;
};

export const updateFulfillmentProductDimensions = async (sku, payload) => {
    const response = await axios.put(
        `${API_BASE_URL}/fulfillment/master-products/${encodeURIComponent(sku)}/dimensions`,
        payload,
        getAuthHeaders(),
    );
    return response.data;
};

export const createInvoiceLine = async (invoiceId, payload) => {
    const response = await axios.post(`${API_BASE_URL}/fulfillment/inbound-invoices/${invoiceId}/lines`, payload, getAuthHeaders());
    return response.data;
};

export const updateInvoiceLine = async (invoiceId, lineId, payload) => {
    const response = await axios.put(`${API_BASE_URL}/fulfillment/inbound-invoices/${invoiceId}/lines/${lineId}`, payload, getAuthHeaders());
    return response.data;
};

export const deleteInvoiceLine = async (invoiceId, lineId) => {
    const response = await axios.delete(`${API_BASE_URL}/fulfillment/inbound-invoices/${invoiceId}/lines/${lineId}`, getAuthHeaders());
    return response.data;
};

export const getFulfillmentRuntimeConfig = async () => {
    const response = await axios.get(`${API_BASE_URL}/fulfillment/runtime-config`, getAuthHeaders());
    return response.data;
};

export const getInvoiceLineMappingSuggestions = async (invoiceId, lineId, query = "") => {
    const response = await axios.get(
        `${API_BASE_URL}/fulfillment/inbound-invoices/${invoiceId}/lines/${lineId}/mapping-suggestions`,
        {
            ...getAuthHeaders(),
            params: query ? { query } : {},
        },
    );
    return response.data;
};

export const updateInvoiceLineMapping = async (invoiceId, lineId, payload) => {
    const response = await axios.put(
        `${API_BASE_URL}/fulfillment/inbound-invoices/${invoiceId}/lines/${lineId}/mapping`,
        payload,
        getAuthHeaders(),
    );
    return response.data;
};

export const checkNpWmsConnection = async () => {
    const response = await axios.get(`${API_BASE_URL}/fulfillment/np-wms/connection-check`, getAuthHeaders());
    return response.data;
};

export const discoverNpApiFulfillmentRefs = async () => {
    const response = await axios.get(`${API_BASE_URL}/fulfillment/np-api/discovery`, getAuthHeaders());
    return response.data;
};

export const getInvoiceStockAudit = async (invoiceId, includeWms = false) => {
    const response = await axios.get(`${API_BASE_URL}/fulfillment/inbound-invoices/${invoiceId}/stock-audit`, {
        ...getAuthHeaders(),
        params: { include_wms: includeWms },
    });
    return response.data;
};

export const listFulfillmentStockSnapshots = async (params = {}) => {
    const response = await axios.get(`${API_BASE_URL}/fulfillment/stock-snapshots`, {
        ...getAuthHeaders(),
        params,
    });
    return response.data;
};

export const getFulfillmentStockSnapshotSummary = async () => {
    const response = await axios.get(`${API_BASE_URL}/fulfillment/stock-snapshots/summary`, getAuthHeaders());
    return response.data;
};

export const syncFulfillmentStockFromNpWms = async (params = {}) => {
    const response = await axios.post(`${API_BASE_URL}/fulfillment/stock-snapshots/np-wms-sync`, {}, {
        ...getAuthHeaders(),
        params,
    });
    return response.data;
};

export const searchDropshipSenderStockProducts = async (query) => {
    const response = await axios.get(`${API_BASE_URL}/fulfillment/dropship-sender-stock/search`, {
        ...getAuthHeaders(),
        params: { query },
    });
    return response.data;
};

export const getDropshipSenderStock = async (sku) => {
    const response = await axios.get(`${API_BASE_URL}/fulfillment/dropship-sender-stock`, {
        ...getAuthHeaders(),
        params: { sku },
    });
    return response.data;
};

export const getDropshipSenderStockAnalogs = async (sku, inStockOnly = true) => {
    const response = await axios.get(`${API_BASE_URL}/fulfillment/dropship-sender-stock/analogs`, {
        ...getAuthHeaders(),
        params: { sku, in_stock_only: inStockOnly },
    });
    return response.data;
};

export const buildNpWmsPlanDryRun = async (invoiceId) => {
    const response = await axios.post(`${API_BASE_URL}/fulfillment/inbound-invoices/${invoiceId}/np-wms/plan-dry-run`, {}, getAuthHeaders());
    return response.data;
};

export const buildNpWmsGoodsDryRun = async (invoiceId, params = {}) => {
    const response = await axios.post(`${API_BASE_URL}/fulfillment/inbound-invoices/${invoiceId}/np-wms/goods-dry-run`, {}, {
        ...getAuthHeaders(),
        params,
    });
    return response.data;
};

export const sendNpWmsGoods = async (invoiceId, params = {}) => {
    const response = await axios.post(`${API_BASE_URL}/fulfillment/inbound-invoices/${invoiceId}/np-wms/goods-send`, {}, {
        ...getAuthHeaders(),
        params,
    });
    return response.data;
};

export const sendNpWmsPlan = async (invoiceId) => {
    const response = await axios.post(`${API_BASE_URL}/fulfillment/inbound-invoices/${invoiceId}/np-wms/plan-send`, {}, getAuthHeaders());
    return response.data;
};

export const sendNpWmsGoodsAndPlan = async (invoiceId, params = {}) => {
    const response = await axios.post(`${API_BASE_URL}/fulfillment/inbound-invoices/${invoiceId}/np-wms/send`, {}, {
        ...getAuthHeaders(),
        params,
    });
    return response.data;
};

export const pollNpWmsFactInbound = async (invoiceId) => {
    const response = await axios.post(`${API_BASE_URL}/fulfillment/inbound-invoices/${invoiceId}/np-wms/fact-poll`, {}, getAuthHeaders());
    return response.data;
};

export const simulateNpWmsFactPlaced = async (invoiceId) => {
    const response = await axios.post(`${API_BASE_URL}/fulfillment/inbound-invoices/${invoiceId}/np-wms/fact-simulate-placed`, {}, getAuthHeaders());
    return response.data;
};

// Маппинг склад → юрлицо (контур фулфилмента)
export const listFulfillmentWarehouseEntities = async () => {
    const response = await axios.get(`${API_BASE_URL}/fulfillment/warehouse-entities`, getAuthHeaders());
    return response.data;
};

export const createFulfillmentWarehouseEntity = async (payload) => {
    const response = await axios.post(`${API_BASE_URL}/fulfillment/warehouse-entities`, payload, getAuthHeaders());
    return response.data;
};

export const updateFulfillmentWarehouseEntity = async (entityId, payload) => {
    const response = await axios.put(`${API_BASE_URL}/fulfillment/warehouse-entities/${entityId}`, payload, getAuthHeaders());
    return response.data;
};

export const deleteFulfillmentWarehouseEntity = async (entityId) => {
    const response = await axios.delete(`${API_BASE_URL}/fulfillment/warehouse-entities/${entityId}`, getAuthHeaders());
    return response.data;
};

// Реестр fulfillment-поставщиков (D14/D15/...)
export const listFulfillmentSupplierConfigs = async () => {
    const response = await axios.get(`${API_BASE_URL}/fulfillment/supplier-configs`, getAuthHeaders());
    return response.data;
};

export const createFulfillmentSupplierConfig = async (payload) => {
    const response = await axios.post(`${API_BASE_URL}/fulfillment/supplier-configs`, payload, getAuthHeaders());
    return response.data;
};

export const updateFulfillmentSupplierConfig = async (configId, payload) => {
    const response = await axios.put(`${API_BASE_URL}/fulfillment/supplier-configs/${configId}`, payload, getAuthHeaders());
    return response.data;
};

export const deleteFulfillmentSupplierConfig = async (configId) => {
    const response = await axios.delete(`${API_BASE_URL}/fulfillment/supplier-configs/${configId}`, getAuthHeaders());
    return response.data;
};
